// Minimal runtime compatibility shims for older browsers used in local dev.
// Keep this file narrow and only add guards for APIs we actively hit in production paths.
const objectWithHasOwn = Object;
if (typeof objectWithHasOwn.hasOwn !== 'function') {
    Object.defineProperty(objectWithHasOwn, 'hasOwn', {
        value: (obj, prop)=>// biome-ignore lint/suspicious/noPrototypeBuiltins: it's dev baby, we gotta be flexible
            Object.prototype.hasOwnProperty.call(Object(obj), prop),
        writable: true,
        configurable: true
    });
}
if (typeof globalThis.structuredClone !== 'function') {
    globalThis.structuredClone = (value)=>JSON.parse(JSON.stringify(value));
}
if (typeof globalThis.crypto?.randomUUID !== 'function') {
    const c = globalThis.crypto ?? {};
    if (!globalThis.crypto) {
        globalThis.crypto = c;
    }
    c.randomUUID = ()=>{
        const hex = Array.from(c.getRandomValues(new Uint8Array(16)), (b)=>b.toString(16).padStart(2, '0'));
        return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex.slice(6, 8).join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10).join('')}`;
    };
}
